import React from 'react';
import ActionButton from 'jbc-front/components/ActionButton';
import { CLIENT_ALLOWANCE_ITEMS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import styles from './FileImport.scss';
import { useTranslation } from 'react-i18next';

const DownloadColumnDetail = () => {
  const { t } = useTranslation();
  return (
    <div className="l-wrap-l">
      <div className="l-overflow-scroll">
        <table className="m-table-description">
          <thead>
            <tr>
              <th className="m-table-description-item-name">{t('features.EmployeeAttendances.components.DownloadColumnDetail.Data_item_name')}</th>
              <th>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Explanation')}</th>
              <th className="m-table-description-example">{t('features.EmployeeAttendances.components.DownloadColumnDetail.Example')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                {t('features.EmployeeAttendances.components.DownloadColumnDetail.Staff_code')}<span className={styles.required}>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Required')}</span>
              </th>
              <td>{t('features.EmployeeAttendances.components.DownloadColumnDetail.alphanumeric_within_10_characters')}</td>
              <td>111</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Last_name')}</th>
              <td>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Can_leave_this_blank_because_staff_is_identified_by_staff_code')}</td>
              <td>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Yamada')}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Name')}</th>
              <td>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Can_leave_this_blank_because_staff_is_identified_by_staff_code')}</td>
              <td>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Taro')}</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeeAttendances.components.DownloadColumnDetail.Payment_date')}<span className={styles.required}>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Required')}</span>
              </th>
              <td>
                dd/mm/yyyy
                <p className="u-mt10">
                  {t('features.EmployeeAttendances.components.DownloadColumnDetail.If_the_filled_in_payment_date_is_different_from_the_payment_date_shown_in_the_page_error_will_occur')}
                </p>
              </td>
              <td>25/01/2025</td>
            </tr>
            <tr>
              <th>
                {t('features.EmployeeAttendances.components.DownloadColumnDetail.Salary_rule_group')}<span className={styles.required}>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Required')}</span>
              </th>
              <td>
                <ActionButton as="a" href={CLIENT_PAYROLL_RULES_GROUP_LIST}>
                  {t('features.EmployeeAttendances.components.DownloadColumnDetail.Confirm_salary_rule_group')}
                </ActionButton>
                <p className="u-mt10">
                  {t('features.EmployeeAttendances.components.DownloadColumnDetail.Attendance_items_available_for_input')}<a href={CLIENT_ALLOWANCE_ITEMS} className="u-txt-link">
                    {t('features.EmployeeAttendances.components.DownloadColumnDetail.Attendance_item_setting')}
                  </a>{t('features.EmployeeAttendances.components.DownloadColumnDetail.different_depending_on_salary_rule_group_used')}
                </p>
              </td>
              <td>{t('features.EmployeeAttendances.components.DownloadColumnDetail.For_full_time_employee')}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Attendance_item_with_Unit_number_of_days')}</th>
              <td>
                {t('features.EmployeeAttendances.components.DownloadColumnDetail.0_00_number_up_to_2_decimal_points')}
                <ul className="m-list-notes u-mt10">
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.If_the_decimal_points_are_not_written_they_will_be_automatically_added')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.If_data_is_left_blank_it_will_not_be_overwritten_Please_fill_in_0_or_0_00_if_you_want_to_overwrite_the_data_with_0')}</li>
                </ul>
                <p className="u-mt10">{t('features.EmployeeAttendances.components.DownloadColumnDetail.Corresponding_attendance_items')}</p>
                <ul className="m-list-notes">
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.prescribed_work_days_in_the_month')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.total_worked_days')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.absent_days')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.paid_vacation_days')}</li>
                  <li>＋</li>
                  <li>
                    {t('features.EmployeeAttendances.components.DownloadColumnDetail.attendance_items_with_unit_days_set')}<a href={CLIENT_ALLOWANCE_ITEMS} className="u-txt-link">
                      {t('features.EmployeeAttendances.components.DownloadColumnDetail.in_attendance_item_setting')}
                    </a>{t('features.EmployeeAttendances.components.DownloadColumnDetail.by_the_user')}
                  </li>
                </ul>
              </td>
              <td>22.00</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeAttendances.components.DownloadColumnDetail.attendance_items_with_unit_hours')}</th>
              <td>
                hh:mm
                <ul className="m-list-notes u-mt10">
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.If_an_integer_such_as_8_is_input_it_will_be_automatically_filled_in_as_8_00_with_decimal_points')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.If_data_is_left_blank_it_will_not_be_overwritten_Please_fill_in_0_or_0_00_if_you_want_to_overwrite_the_data_with_0')}</li>
                </ul>
                <p className="u-mt10">{t('features.EmployeeAttendances.components.DownloadColumnDetail.Corresponding_attendance_items')}</p>
                <ul className="m-list-notes">
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.prescribed_work_hours_in_the_month')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.work_hours_within_prescrtiption')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.off_schedule_work_hours')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.total_work_hours')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.holiday_work_hours')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.late_and_early_leave_hours')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.OT_hours')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.night_work_hours')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.paid_vacation_hours')}</li>
                  <li>＋</li>
                  <li>
                    {t('features.EmployeeAttendances.components.DownloadColumnDetail.attendance_items_with_unit_hours_set')}<a href={CLIENT_ALLOWANCE_ITEMS} className="u-txt-link">
                      {t('features.EmployeeAttendances.components.DownloadColumnDetail.in_attendance_item_setting')}
                    </a>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Attendance_items_that_set_as_unit_hours_in')}
                  </li>
                </ul>
              </td>
              <td>8:45</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeAttendances.components.DownloadColumnDetail.attendance_items_with_unit_times')}</th>
              <td>
                {t('features.EmployeeAttendances.components.DownloadColumnDetail.0_00_number_up_to_2_decimal_points')}
                <ul className="m-list-notes u-mt10">
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.If_the_decimal_points_are_not_written_they_will_be_automatically_added')}</li>
                  <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.If_data_is_left_blank_it_will_not_be_overwritten_Please_fill_in_0_or_0_00_if_you_want_to_overwrite_the_data_with_0')}</li>
                </ul>
                <p className="u-mt10">{t('features.EmployeeAttendances.components.DownloadColumnDetail.Corresponding_attendance_items')}</p>
                <ul>
                  <li>
                    {t('features.EmployeeAttendances.components.DownloadColumnDetail.attendance_items_with_unit_days_set')}<a href={CLIENT_ALLOWANCE_ITEMS} className="u-txt-link">
                      {t('features.EmployeeAttendances.components.DownloadColumnDetail.Attendance_item_setting')}
                    </a>{t('features.EmployeeAttendances.components.DownloadColumnDetail.attendance_items_set_with_unit_times')}
                  </li>
                </ul>
              </td>
              <td>1.00</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.notes}>
        <ul className="m-list-notes u-mt10">
          <li>
            {t('features.EmployeeAttendances.components.DownloadColumnDetail.About_attendance_items_you_want_to_use')}<a href={CLIENT_ALLOWANCE_ITEMS} className="u-txt-link">
              {t('features.EmployeeAttendances.components.DownloadColumnDetail.Attendance_item_setting')}
            </a>{t('features.EmployeeAttendances.components.DownloadColumnDetail.Items_which_are_checked_as_OFF_in_applicable_salary_rule_group_are_not_available_for_upload')}
          </li>
          <li>
            {t('features.EmployeeAttendances.components.DownloadColumnDetail.These_attendance_items_are_set_in_salary_rule_group_and_cannot_be_set_here_Please_go_to')}<a
              href={CLIENT_PAYROLL_RULES_GROUP_LIST}
              className="u-txt-link"
            >
              {t('features.EmployeeAttendances.components.DownloadColumnDetail.Salary_rule')}
            </a>{t('features.EmployeeAttendances.components.DownloadColumnDetail.to_change_the_setting')}
            <ul>
              <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.prescribed_work_hours_in_1_day')}</li>
              <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.monthly_average_prescribed_work_days')}</li>
              <li>{t('features.EmployeeAttendances.components.DownloadColumnDetail.monthly_average_prescribed_work_hours')}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DownloadColumnDetail;
